import { UserRole } from '@shared/utils/base-auth';

export class RouteAccessRoles {
  constructor(public route: string, public userRoles: UserRole[]) {}
}
